{
  "fontFamilyMap": {
    "light": "Larsseit-Light",
    "medium": "Larsseit-Medium",
    "bold": "Larsseit-Bold",
    "regular": "Larsseit"
  },
  "definitions": {
    "60": {
      "element": "h1",
      "lineHeight": [90],
      "fontFamily": ["light"],
      "letterSpacing": [-1.5]
    },
    "48": {
      "element": "h2",
      "lineHeight": [72],
      "fontFamily": ["regular"],
      "letterSpacing": [-0.5]
    },
    "34": {
      "element": "h3",
      "lineHeight": [52],
      "fontFamily": ["regular"]
    },
    "24": {
      "element": "h4",
      "lineHeight": [36],
      "fontFamily": ["regular"],
      "letterSpacing": [0.25]
    },
    "20": {
      "element": "h5",
      "lineHeight": [30],
      "fontFamily": ["regular"]
    },
    "18": {
      "element": "h5",
      "lineHeight": [28, 28],
      "fontFamily": ["regular", "medium"],
      "letterSpacing": [0.15, 0.15]
    },
    "18.5": {
      "element": "h5",
      "lineHeight": [28],
      "fontFamily": ["medium"],
      "letterSpacing": [0.25]
    },
    "17.5": {
      "element": "h5",
      "lineHeight": [28],
      "fontFamily": ["regular"],
      "letterSpacing": [0.15]
    },
    "16": {
      "element": "h6",
      "lineHeight": [24, 24],
      "fontFamily": ["regular", "medium"],
      "letterSpacing": ["inherit", 0.15]
    },
    "14": {
      "element": "p",
      "lineHeight": [22, 22],
      "fontFamily": ["regular", "medium"],
      "letterSpacing": [0.25, 0.1]
    },
    "12": {
      "element": "p",
      "lineHeight": [18],
      "fontFamily": ["regular"],
      "letterSpacing": [0.4]
    },
    "10": {
      "element": "p",
      "lineHeight": [16],
      "fontFamily": ["regular"],
      "letterSpacing": [0.5]
    }
  },
  "marketingDefinitions": {
    "48": {
      "element": "h1",
      "lineHeight": [60],
      "fontFamily": ["bold"],
      "letterSpacing": [-1.6]
    },
    "32": {
      "element": "h2",
      "lineHeight": [40],
      "fontFamily": ["bold"],
      "letterSpacing": [-0.99]
    },
    "24": {
      "element": "h3",
      "lineHeight": [36, 32],
      "fontFamily": ["regular", "bold"],
      "letterSpacing": [-0.44, "normal"]
    },
    "21": {
      "element": "h4",
      "lineHeight": [31.5],
      "fontFamily": ["medium"],
      "letterSpacing": [-0.44]
    },
    "18": {
      "element": "p",
      "lineHeight": [27],
      "fontFamily": ["regular"]
    },
    "16": {
      "element": "p",
      "lineHeight": [24, 28, 24],
      "fontFamily": ["regular", "medium", "bold"],
      "letterSpacing": ["normal", 0.25, "normal"]
    },
    "14": {
      "element": "p",
      "lineHeight": [21, 14, 21],
      "fontFamily": ["regular", "medium", "bold"],
      "letterSpacing": ["normal", 2, "normal"]
    }
  }
}
